module.exports = __webpack_public_path__ + "static/a6-5c90e31bc7fa7b131ab9182ec2355bd8.svg";